import React from "react";
import { Link } from "react-router-dom";

import { Button } from "components/ui/Button";
import { pathGenerators } from "utils/routes";

import styles from "./NotFoundPage.module.css";

const NotFoundPage = () => {
  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.text}>
        This URL does not match any screen in Kinesin. Check the link or use the
        menu to continue.
      </p>
      <Button as={Link} variant="primary" size="large" to={pathGenerators.global.home()}>
        Go to home
      </Button>
    </div>
  );
};

export { NotFoundPage };
